<template>
  <div>
    <div class="content-header" style="border: none">
      <div class="left">
        <span class="title">分账详情</span>
      </div>
    </div>
    <div class="list-tab">
      <span @click="typeClick('2')" :class="{ current: tab_val == '2' }">收款人角度</span>
      <span @click="typeClick('1')" :class="{ current: tab_val == '1' }">设备角度</span>
      <span @click="typeClick('0')" :class="{ current: tab_val == '0' }">订单角度</span>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <span>1、所有类型用户通过扫码或个人会员钱包支付的订单将进行分账，企业员工如开通扫码支付功能也将进行分账，通过企业钱包、员工配额、员工钱包产生的订单不进行分账，请线下与企业进行结算；<br />
        <span>2、下列数据默认按分账时间进行统计显示，如要将“印量报表-消费统计”中的数据与本表进行核对，请将分账时间切换为订单时间，或者分账时间向后延1天，如统计1-30号，分账时间设为2-31号；</span><br />
        <span style="color: red">3、因订单量激增，当日对前一天订单进行分账时可能会排队，如果下列部份订单的分账状态为“排队中”，请稍后再查询统计；</span>
      </span>
    </div>
    <div class="filter-box">
      <div>
        <span class="subtitle">分账单号:　</span>
        <Input v-model="page.trans_no" placeholder="请输入分账单号" style="width: 200px; margin: 0 10px"
          :disabled="tab_val != '0'">
        </Input>
        <span class="subtitle">订单ID:　</span>
        <Input v-model="page.order_id" placeholder="请输入订单ID" style="width: 200px; margin: 0 10px"
          :disabled="tab_val != '0'">
        </Input>
        <span class="subtitle">收款人:　</span>
        <Input v-model="page.account_name" placeholder="请输入收款人" style="width: 190px; margin: 0 10px"
          :disabled="tab_val == '1'">
        </Input>
        <span class="subtitle">收款人ID:</span>
        <Input v-model="page.account_id" placeholder="请输入收款人ID" style="width: 190px; margin: 0 10px"
          :disabled="tab_val == '1'"></Input>
      </div>
      <div style="margin-top: 10px">
        <span class="subtitle">设备序列号:</span>
        <Input v-model="page.sn" placeholder="请输入设备序列号" style="width: 200px; margin: 0 10px"
          :disabled="tab_val == '2'" />
        <span class="subtitle">设备站点:</span>
        <Input v-model="page.site_name" placeholder="请输入设备站点" style="width: 200px; margin: 0 10px"
          :disabled="tab_val == '2'" />
        <span class="subtitle">分账状态:</span>
        <Select v-model="page.status" style="width: 190px; margin-left: 10px"
          :disabled="tab_val == '1' || tab_val == '2'">
          <Option :value="-1" :key="-1">全部</Option>
          <Option :value="1" :key="1">已转账</Option>
          <Option :value="0" :key="0">排队中</Option>
          <Option :value="2" :key="2">转账失败</Option>
        </Select>
        <span class="subtitle" style="margin-left: 10px">分账方向:</span>
        <Select v-model="page.mode" style="width: 190px; margin-left: 10px"
          :disabled="tab_val == '1' || tab_val == '2'">
          <Option :value="-1" :key="-1">全部</Option>
          <Option value="0" :key="0">收款人账户</Option>
          <Option value="1" :key="1">支付宝账户</Option>
        </Select>
      </div>
      <div style="margin-top: 10px">
        <Select v-model="page.date_type" style="width: 90px">
          <Option :value="0" :key="0">分账时间</Option>
          <Option :value="1" :key="1">作业时间</Option>
        </Select>
        <DatePicker type="date" v-model="page.start" placeholder="开始时间" @on-change="changeDate"
          style="width: 125px; margin-left: 10px"></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker type="date" v-model="page.end" placeholder="结束时间" @on-change="changeDate" style="width: 125px">
        </DatePicker>
        <RadioGroup type="button" style="margin-left: 10px" v-model="radio" @on-change="onChangeSelectData">
          <Radio label="0">
            <span>今&nbsp;&nbsp;日</span>
          </Radio>
          <Radio label="1">
            <span>本 月</span>
          </Radio>
          <Radio label="2">
            <span>上 月</span>
          </Radio>
        </RadioGroup>
        <span v-if="!agent.tp" class="subtitle" style="margin-left: 10px">合作伙伴:</span>
        <Input v-if="!agent.tp" v-model="page.agent_name" placeholder="请输入合作伙伴" style="width: 200px; margin: 0 10px" />
        <Checkbox style="margin-left: 12px" v-model="page.is_del" v-if="tab_val === '1'">查询已删除设备</Checkbox>
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="tableLoading ? null : getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
    <div style="text-align: center; color: #000; font-weight: bold">
      汇总时间：{{ $moment(page.start, "YYYY/MM/DD") }}-{{
        $moment(page.end, "YYYY/MM/DD")
      }}（仅汇总分账状态为已转账记录）
    </div>
    <div class="statistics-box">
      <div class="item">
        <div>
          <p class="title">
            订单到账金额(元)
            <Tooltip placement="top">
              <Icon class="icon" type="ios-help-circle-outline" size="14" />
              <div slot="content" style="white-space: normal">
                等于订单管理中的到账金额，包含了所有分账状态的记录（如有差异，可能发生了分账后退款的情况）
              </div>
            </Tooltip>
          </p>
          <p class="money">{{ statistics.orderMoney }}</p>
          <div class="title" style="margin-top: 5px">
            排队
            <span style="color: #2d8cf0; margin-right: 5px">{{
              statistics.noOrderMoney
            }}</span>
            已分
            <span style="color: #2d8cf0; margin-right: 5px">{{
              statistics.yorderMoney
            }}</span>
            失败 <span style="color: #2d8cf0">{{ statistics.orderMoneyError }}</span>
          </div>
        </div>
      </div>
      <div class="item">
        <div>
          <p class="title">
            分账总金额(元)
            <Tooltip placement="top">
              <Icon class="icon" type="ios-help-circle-outline" size="14" />
              <div slot="content" style="white-space: normal">
                收款人账户与支付宝账户合计入账（不能用订单到账金额-交易手续费，因为多级分账时，有可能部份收款人的支付宝账户入账因不足0.1,失败后会累计到后面分账）
              </div>
            </Tooltip>
          </p>
          <p class="money">{{ statistics.dispenseMoney }}</p>
          <div class="title">
            分账后退款
            <span style="color: #2d8cf0; cursor: pointer; margin-top: 5px" @click="showDetail">{{ refundMoney }}</span>
          </div>
        </div>
      </div>
      <div class="item">
        <div>
          <p class="title">
            分账至收款人账户(元)
            <tooltip placement="top">
              <Icon class="icon" type="ios-help-circle-outline" size="14" />
              <div slot="content" style="white-space: normal">
                此账户接收所有类型用户，通过微信或支付宝支付的订单收益
              </div>
            </tooltip>
          </p>
          <p class="money">{{ statistics.accountMoney }}</p>
          <div class="title" style="color: #2d8cf0; cursor: pointer" @click="goWithdraw">
            去提现
          </div>
        </div>
      </div>
      <div class="item">
        <div>
          <p class="title">
            分账至支付宝账户(元)
            <tooltip placement="top">
              <Icon class="icon" type="ios-help-circle-outline" size="14" />
              <div slot="content" style="white-space: normal">
                此账户接收用户通过个人会员钱包支付的订单收益（如与实际到账不符，请确认是否有分账后退款）
              </div>
            </tooltip>
          </p>
          <p class="money">{{ statistics.alipayMoney }}</p>
          <div class="title">每日自动到账</div>
        </div>
      </div>
      <div class="item">
        <div>
          <p class="title">
            交易手续费(元)
            <Tooltip placement="top">
              <Icon class="icon" type="ios-help-circle-outline" size="14" />
              <div slot="content" style="white-space: normal">
                每笔订单按“到账金额”收取交易手续费（费率至合作伙伴后台个人中心查询），最低每笔订单收取0.01元（此金额未扣除分账后全额退款产生的手续费回退）
              </div>
            </Tooltip>
          </p>
          <p class="money" style="color: red">-{{ statistics.feeMoney }}</p>
        </div>
      </div>
    </div>
    <div style="position: relative">
      <Table :columns="tab_val == '0' ? columns : tab_val == '1' ? columns2 : columns3" :data="data"
        :loading="tableLoading">
      </Table>
      <div class="t-right">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total"
          show-elevator show-sizer show-total />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <!-- <Drawer title="退款记录" :width="340" :closable="true" v-model="drawer" :mask-style="{ backgroundColor: 'transparent' }"
      :styles="{ padding: '16px 0' }">
      <Table height="400" :columns="returns_columns" :data="returns" :footer-hide="true" show-summary
        :summary-method="handleSummary" />
    </Drawer> -->
    <Modal v-model="refundModal.visible" title="分账后退款记录" :width="1100">
      <div class="tips" style="margin-bottom: 20px">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
        <div>
          支付方式为会员钱包的订单，因累计后一次性分账至收款人的支付宝账户，发生分账后退款时，将计算该订单退款金额所对应的收款人该退回多少，然后合计退回金额后从第二天分账时退回
        </div>
      </div>
      <div class="filter-box">
        <div style="margin-bottom: 15px">
          <span class="subtitle">自定查找:</span>
          <Input style="width: 260px; margin-left: 6px" placeholder="关键字查找" v-model="refundPage.search" />
          <span class="subtitle" style="margin-left: 12px">查询时间:</span>
          <DatePicker type="date" v-model="refundPage.start_date" placeholder="开始时间"
            style="width: 120px; margin-left: 10px">
          </DatePicker>
          <span style="margin: 0 5px">至</span>
          <DatePicker type="date" v-model="refundPage.end_date" placeholder="结束时间"
            style="width: 120px; margin-right: 10px">
          </DatePicker>
        </div>
        <div class="bottom">
          <span class="btn-filter" @click="getRefundData">查询</span>
          <span class="btn" @click="resetRefund">清空</span>
          <Poptip title="导出Excel" placement="right" trigger="hover">
            <span class="btn">导出报表</span>
            <div slot="content">
              <Button type="primary" style="margin-right: 5px" @click="exportRefund(0)">导出当前页</Button>
              <Button type="success" @click="exportRefund(1)">导出所有页</Button>
            </div>
          </Poptip>
        </div>
      </div>
      <Table :columns="returns_columns" :data="returns" :footer-hide="true" />
      <div class="t-right" style="margin-top: 20px">
        <Page @on-change="refundPageChange" @on-page-size-change="refundSizeChange" :total="refundModal.refundTotal"
          show-elevator show-sizer show-total />
      </div>
      <div slot="footer">
        <Button @click="refundModal.visible = false">关闭</Button>
        <!-- <Button type="primary" v-preventReClick @click="exportRefund" :loading="refundModal.loading">导出报表</Button> -->
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { monDiff, verifyDate } from '@/libs/util'
import config from '@/config'
export default {
  data () {
    return {
      tab_val: '2',
      data: [],
      statistics: {
        accountMoney: '0.00',
        alipayMoney: '0.00',
        dispenseMoney: '0.00',
        feeMoney: '0.00',
        orderMoney: '0.00',
        yorderMoney: '0.00',
        noOrderMoney: '0.00',
        orderMoneyError: '0.00'
      },
      refundMoney: '0.00',
      total: 0,
      tableLoading: false,
      columns: [
        {
          key: 'trans_time',
          width: 135,
          title: '分账时间',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.trans_time))
          }
        },
        // { key: "id", width: 110, title: "分账ID", tooltip: true },
        {
          key: 'trans_no',
          width: 150,
          title: '分账单号',
          tooltip: true,
          render: (h, data) => {
            return h('span', data.row.trans_no ? data.row.trans_no : '-')
          }
        },
        {
          key: 'job_time',
          width: 135,
          title: '作业时间',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.job_time))
          }
        },
        { key: 'order_id', width: 120, title: '订单ID' },
        // { key: "order_no", width: 160, title: "作业单号", tooltip: true },
        // { key: "pay_no", width: 160, title: "订单号", tooltip: true },
        { key: 'sn', width: 120, title: '设备序列号' },
        {
          key: 'meter',
          width: 100,
          title: '设备类型',
          tooltip: true,
          render: (h, data) => {
            const arr = ['云知印', '智能运维', '常规运维', '云知印mini']
            return h('span', {}, arr[data.row.meter])
          }
        },
        {
          key: 'site_name',
          width: 115,
          title: '站点',
          tooltip: true
        },
        { key: 'agent_name', width: 160, title: '合作伙伴', tooltip: true },
        {
          key: 'fee_scale',
          width: 80,
          title: '费率',
          tooltip: true,
          render: (h, data) => {
            return h('span', {}, data.row.fee_scale ? data.row.fee_scale + '%' : '1%')
          }
        },
        {
          key: 'job_status',
          width: 130,
          title: '订单状态',
          tooltip: true,
          render: (h, data) => {
            let status = {
              '-1': '订单创建',
              0: '支付完成',
              1: '订单完成',
              2: '订单异常未退款',
              4: '退款成功',
              5: '删除',
              7: '退款失败',
              8: '订单结束'
            }
            return h('span', {}, status[`${data.row.job_status}`])
          }
        },

        {
          key: 'user_type',
          width: 90,
          title: '用户类型',
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.user_id ? (data.row.staff_id ? '会员(企业)' : '会员') : '游客'
            )
          }
        },
        {
          key: 'user_id',
          width: 90,
          title: '用户ID',
          render: (h, data) => {
            return h('span', data.row.user_id ? data.row.user_id : '-')
          }
        },
        {
          key: 'money_type',
          width: 100,
          title: '支付方式',
          render: (h, data) => {
            let money_type = {
              0: { name: '钱包' },
              1: { name: '微信' },
              2: { name: '支付宝' },
              3: { name: '免费' },
              4: { name: '企业钱包' },
              5: { name: '员工配额' },
              // 6: { name: "临时配额" },
              6: { name: '员工钱包' }
            }
            return h('span', money_type[data.row.money_type].name)
          }
        },

        { key: 'account_id', width: 90, title: '收款人ID' },
        {
          key: 'account_name',
          width: 115,
          title: '收款人',
          tooltip: true,
          fixed: 'right'
        },
        {
          key: 'mode',
          width: 115,
          title: '分账方向',
          render: (h, data) => {
            return h('span', data.row.mode ? '支付宝账户' : '收款人账户')
          }
        },
        {
          key: 'type',
          width: 115,
          title: '收款人类型',
          render: (h, data) => {
            const userType = data.row.account_type || data.row.type
            return h('span', userType === 3 ? '个人' : '企业')
          }
        },
        {
          key: 'remark',
          width: 115,
          title: '去重标识',
          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              {
                props: { size: 'small', placement: 'top', transfer: true }
              },
              [
                h('span', [
                  h('span', '去重标识'),
                  h('Icon', {
                    props: { type: 'md-alert', size: 14 },
                    style: {
                      marginLeft: '5px'
                    }
                  })
                ]),
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  '拥有“去重”标识的记录一般属于多级分账订单，一条订单会按收款人角度拆分成多条记录显示，导出报表后如果要按“到账金额”“手续费”“结算金额”进行汇总，请将去重标识的记录过滤掉再统计，不然可能会数值翻倍'
                )
              ]
            )
          }
        },
        {
          key: 'status',
          width: 110,
          maxWidth: 110,
          title: '分账状态',
          show: true,
          ellipsis: true,
          fixed: 'right',
          render: (h, data) => {
            // 0未转账 1已转账 2转账失败
            let text = ''
            switch (data.row.status) {
              case 0:
                text = '排队中'
                break
              case 1:
                text = '已转账'
                break
              case 2:
                text = `转账失败(${data.row.note})`
                break
              default:
                break
            }
            return h(
              'Tooltip',
              {
                props: { size: 'small', placement: 'top', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    style: {
                      color:
                        data.row.status == 0
                          ? '#f90'
                          : data.row.status == 1
                            ? '#515a6e'
                            : '#ed4014'
                    }
                  },
                  text
                ),
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  text
                )
              ]
            )
          }
        },
        { key: 'total_amount', width: 108, title: '订单到账金额', fixed: 'right' },
        { key: 'fee', width: 84, title: '手续费', fixed: 'right' },
        { key: 'amount', width: 84, title: '结算金额', fixed: 'right' },
        {
          key: 'scale',
          width: 84,
          title: '分账比例',
          fixed: 'right',
          render: (h, data) => {
            return h('span', parseInt(data.row.scale) + '%')
          }
        },
        {
          key: 'trans_amount',
          width: 84,
          title: '分账金额',
          fixed: 'right'
        }
      ],
      columns2: [
        { key: 'sn', width: 120, title: '设备序列号' },
        {
          key: 'meter',
          width: 100,
          title: '设备类型',
          tooltip: true,
          render: (h, data) => {
            const arr = ['云知印', '智能运维', '常规运维', '云知印mini']
            return h('span', {}, arr[data.row.meter])
          }
        },
        {
          key: 'site_name',
          title: '设备站点',
          tooltip: true
        },
        { key: 'agent_name', title: '合作伙伴', tooltip: true },

        { key: 'total_amount', title: '订单到账金额' },
        { key: 'fee', title: '手续费' },
        { key: 'amount', title: '结算金额' },
        {
          key: 'trans_amount',
          title: '分账总金额',
          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              {
                props: { size: 'small', placement: 'top', transfer: true }
              },
              [
                h('span', [
                  h('span', '分账总金额'),
                  h('Icon', {
                    props: { type: 'md-alert', size: 14 },
                    style: {
                      marginLeft: '5px'
                    }
                  })
                ]),
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  '分账总金额=分账至收款人账户+分账至支付宝账户'
                )
              ]
            )
          }
        }
      ],
      columns3: [
        { key: 'id', title: '收款人ID' },
        { key: 'name', title: '收款人名称', tooltip: true },
        { key: 'email', title: '收款人账号', tooltip: true },
        {
          key: 'type',
          title: '收款人类型',
          tooltip: false,
          render: (h, data) => {
            const userType = data.row.account_type || data.row.type
            return h('span', userType === 3 ? '个人' : '企业')
          }
        },
        { key: 'agent_name', title: '合作伙伴', tooltip: true },
        // { key: "total_amount", title: "订单到账金额" },
        // { key: "fee", title: "手续费" },
        // { key: "amount", title: "结算金额" },
        { key: 'account_money', title: '分账至收款人账户' },
        { key: 'alipay_money', title: '分账至支付宝账户' },
        {
          key: 'trans_amount',
          title: '分账总金额',
          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              {
                props: { size: 'small', placement: 'top', transfer: true }
              },
              [
                h('span', [
                  h('span', '分账总金额'),
                  h('Icon', {
                    props: { type: 'md-alert', size: 14 },
                    style: {
                      marginLeft: '5px'
                    }
                  })
                ]),
                h(
                  'span',
                  {
                    slot: 'content',
                    style: {
                      whiteSpace: 'normal'
                    }
                  },
                  '分账总金额=分账至收款人账户+分账至支付宝账户'
                )
              ]
            )
          }
        }
      ],
      machine: [],
      returns: [],
      drawer: false,
      returns_columns: [
        {
          key: 'create_time',
          title: '退款时间',
          width: 135,
          render: (h, data) => {
            return h('span', this.$moment(data.row.create_time))
          }
        },
        {
          key: 'order_time',
          title: '订单时间',
          width: 135,
          render: (h, data) => {
            return h('span', this.$moment(data.row.order_time))
          }
        },
        { key: 'order_id', title: '订单ID', width: 150 },
        {
          key: 'mode',
          title: '分账方向',
          width: 150,
          render: (h, data) => {
            return h('span', data.row.mode ? '支付宝账户' : '收款人账户')
          }
        },
        { key: 'account_id', title: '收款人ID', width: 100 },
        { key: 'amount', title: '退款金额', width: 100 },
        { key: 'status', title: '回退状态', width: 150 },
        { key: 'note', title: '备注' }
      ],
      radio: '0',
      page: {
        l: 10,
        p: 0,
        date_type: 0,
        trans_no: '',
        pay_no: '',
        account_name: '',
        account_id: '',
        sn: '',
        site_name: '',
        agent_name: '',
        status: -1,
        start: new Date(),
        end: new Date(),
        mode: -1,
        is_del: false
      },
      startOptions: {
        disabledDate: (date) => {
          let data = this.page.end == '' ? Date.now() : this.page.end
          return date >= data
        }
      }, // 开始日期设置
      endOptions: {
        // 指定终止日期
        disabledDate: (date) => {
          let data = this.page.start == '' ? '' : this.page.start
          return date < data
        }
      }, // 结束日期设置
      refundModal: {
        visible: false,
        loading: false,
        refundTotal: 0
      },
      refundPage: {
        search: '',
        start_date: new Date(),
        end_date: new Date(),
        p: 0,
        l: 10
      }
    }
  },
  mounted () {
    this.tableLoading = true
    this.getData(1)
  },
  methods: {
    typeClick (tab) {
      this.tab_val = tab
      this.page = {
        l: 10,
        p: 0,
        date_type: 0,
        trans_no: '',
        pay_no: '',
        account_name: '',
        account_id: '',
        sn: '',
        site_name: '',
        agent_name: '',
        status: -1,
        start: new Date(),
        end: new Date(),
        mode: -1,
        is_del: 0
      }
      this.radio = '0'
      this.getData(1)
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      let diff = monDiff(this.page.start, this.page.end)

      if (diff > 3) {
        // 如果时间跨度超过一年就提示
        this.$Message.error('筛选的时间跨度不能超过3个月')
        return
      }
      let search = {
        start_date: this.$moment(this.page.start, 'YYYY-MM-DD'),
        end_date: this.$moment(this.page.end, 'YYYY-MM-DD'),
        mode: this.page.mode == -1 ? null : this.page.mode,
        status: this.page.status == -1 ? null : this.page.status,
        ...this.page
      }
      this.tableLoading = true
      switch (this.tab_val) {
        case '0':
          this.GetDispenseDetailed(search).then((res) => {
            this.tableLoading = false
            this.total = res.total
            this.data = res.data
            this.markDuplicateData(this.data, 'remark')
          })
          break
        case '1':
          this.data = []
          this.GetDataMachine({
            search: this.page.sn || this.page.site_name,
            agent_name: this.page.agent_name,
            p: this.page.p,
            l: this.page.l,
            is_del: this.page.is_del ? 1 : 0
          }).then((res) => {
            this.total = res.total
            let ids = [],
              machineList = res.data
            res.data.forEach((item) => {
              ids.push(item.id)
            })
            search.ids = ids.join(',')
            search.angle = 0
            this.GetAngleDispenseDetailed(search).then((res) => {
              this.tableLoading = false
              machineList.map((item) => {
                item.total_amount = 0
                item.amount = 0
                item.fee = 0
                item.trans_amount = 0

                res.data.map((it) => {
                  if (item.id == it.machine_id) {
                    item.total_amount = it.total_amount
                    item.amount = it.amount
                    item.fee = it.fee
                    item.trans_amount = it.trans_amount
                  }
                })
              })
              machineList.sort((a, b) => b.trans_amount - a.trans_amount)
              this.data = machineList
            })
          })
          break
        case '2':
          this.data = []
          this.GetPayee({
            cond: 'id',
            value: this.page.account_id,
            account_name: this.page.account_name,
            agent_name: this.page.agent_name,
            p: this.page.p,
            l: this.page.l
          }).then((res) => {
            this.total = res.total
            let ids = [],
              dataList = res.data
            res.data.forEach((item) => {
              ids.push(item.id)
            })
            search.ids = ids.join(',')
            search.angle = 1
            this.GetAngleDispenseDetailed(search).then((res) => {
              this.tableLoading = false
              dataList.map((item) => {
                // item.total_amount = 0;
                // item.amount = 0;
                // item.fee = 0;
                item.account_money = 0
                item.alipay_money = 0
                item.trans_amount = 0
                res.data.map((it) => {
                  if (item.id == it.account_id) {
                    // item.total_amount = it.total_amount;
                    // item.amount = it.amount;
                    // item.fee = it.fee;
                    item.account_money = it.account_money
                    item.alipay_money = it.alipay_money
                    item.trans_amount = it.trans_amount
                  }
                })
              })
              dataList.sort((a, b) => b.trans_amount - a.trans_amount)
              this.data = dataList
            })
          })

          break
      }
      if (filter) {
        this.getTotal(search)
        this.GetDispenseRefundMoney(search).then((res) => {
          if (res.status) {
            this.refundMoney = res.data.money
          } else {
            this.refundMoney = '0.00'
          }
        })
      }
    },
    getTotal (search) {
      this.statistics = {
        accountMoney: '0.00',
        alipayMoney: '0.00',
        dispenseMoney: '0.00',
        feeMoney: '0.00',
        orderMoney: '0.00',
        yorderMoney: '0.00',
        noOrderMoney: '0.00',
        orderMoneyError: '0.00'
      }
      this.GetDispenseTotal(search).then((res) => {
        this.statistics = res.data
      })
    },
    // 判断重复订单添加‘去重’标识
    markDuplicateData (arr, mark) {
      let countObj = {} // 记录每个数据出现的次数
      arr.forEach((obj) => {
        let key = obj.order_id // 将order_id字段作为判断重复条件
        countObj[key] = countObj[key] ? countObj[key] + 1 : 1 // 记录出现次数
      })
      arr.forEach((obj, index) => {
        let key = obj.order_id
        if (countObj[key] > 1) {
          if (countObj[key] === 2 && arr.findIndex((o) => o.order_id === key) === index) {
            return // 如果是第一次出现，则不添加标识
          }
          obj[mark] = '去重' // 添加标识
        }
      })
      return arr
    },
    async exportData (is_all) {
      let time = this.page.date_type == 0 ? '分账时间:' : '作业时间:'
      time +=
        this.$moment(this.page.start, 'YYYY-MM-DD') +
        '至' +
        this.$moment(this.page.end, 'YYYY-MM-DD')
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '分账详情-' + time
      }
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }

      let columns = []
      switch (this.tab_val) {
        case '0':
          columns = this.columns
          break
        case '1':
          columns = this.columns2
          break
        case '2':
          columns = this.columns3
          break
      }
      columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        this.tableLoading = true
        let search = {
          start_date: this.$moment(this.page.start, 'YYYY-MM-DD'),
          end_date: this.$moment(this.page.end, 'YYYY-MM-DD'),
          type: this.page.type == -1 ? null : this.page.type,
          status: this.page.status == -1 ? null : this.page.status,
          ...this.page
        }
        search.p = 0
        search.l = 1000000
        this.getAngleData(search, params)
      } else {
        if (this.tab_val == '0' || this.tab_val == '2') {
          params.data = this.formatExportData(this.data)
        } else {
          params.data = this.data
        }
        excel.export_array_to_excel(params)
      }
    },
    getAngleData (search, params) {
      let data = []
      this.tableLoading = true
      switch (this.tab_val) {
        case '0':
          this.GetDispenseDetailed(search).then((res) => {
            this.tableLoading = false
            data = this.markDuplicateData(res.data, 'remark')
            params.data = this.formatExportData(data)
            excel.export_array_to_excel(params)
          })
          break
        case '1':
          this.GetDataMachine({
            search: this.page.sn,
            agent_name: this.page.agent_name,
            p: 0,
            l: 100000
          }).then((res) => {
            // this.total = res.total;
            let ids = [],
              machineList = res.data
            res.data.forEach((item) => {
              ids.push(item.id)
            })
            search.ids = ids.join(',')
            search.angle = 0
            this.GetAngleDispenseDetailed(search).then((res) => {
              this.tableLoading = false
              machineList.map((item) => {
                item.total_amount = 0
                item.amount = 0
                item.fee = 0
                item.trans_amount = 0

                res.data.map((it) => {
                  if (item.id == it.machine_id) {
                    item.total_amount = it.total_amount
                    item.amount = it.amount
                    item.fee = it.fee
                    item.trans_amount = it.trans_amount
                  }
                })
              })
              machineList.sort((a, b) => b.trans_amount - a.trans_amount)
              data = machineList
              params.data = this.formatExportData(data)
              excel.export_array_to_excel(params)
            })
          })
          break
        case '2':
          this.GetPayee({
            cond: 'id',
            value: this.page.account_id,
            account_name: this.page.account_name,
            agent_name: this.page.agent_name,
            p: 0,
            l: 100000
          }).then((res) => {
            let ids = [],
              dataList = res.data
            res.data.forEach((item) => {
              ids.push(item.id)
            })
            search.ids = ids.join(',')
            search.angle = 1
            this.GetAngleDispenseDetailed(search).then((res) => {
              this.tableLoading = false
              dataList.map((item) => {
                item.account_money = 0
                item.alipay_money = 0
                item.trans_amount = 0
                res.data.map((it) => {
                  if (item.id == it.account_id) {
                    item.account_money = it.account_money
                    item.alipay_money = it.alipay_money
                    item.trans_amount = it.trans_amount
                  }
                })
              })
              dataList.sort((a, b) => b.trans_amount - a.trans_amount)
              data = dataList
              params.data = this.formatExportData(data)
              excel.export_array_to_excel(params)
            })
          })
          break
      }
      return data
    },
    formatExportData (data) {
      data = JSON.parse(JSON.stringify(data))
      this.markDuplicateData(data, 'remark')
      let status = {
        0: '排队中',
        1: '已转账',
        2: '转账失败'
      }
      let job_status = {
        '-1': '订单创建',
        0: '支付完成',
        1: '订单完成',
        2: '订单异常未退款',
        4: '退款成功',
        5: '删除',
        7: '退款失败',
        8: '订单结束'
      }
      let money_type = {
        0: { name: '钱包' },
        1: { name: '微信' },
        2: { name: '支付宝' },
        3: { name: '免费' },
        4: { name: '企业钱包' },
        5: { name: '员工配额' },
        // 6: { name: "临时配额" },
        6: { name: '员工钱包' }
      }
      let types = {
        3: '个人',
        2: '企业'
      }
      data.map((item) => {
        item.job_time = this.$moment(item.job_time)
        item.trans_time = this.$moment(item.trans_time)
        item.ID = item.user_id ? item.user_id : item.open_id
        // item.type = item.user_id ? "支付宝" : item.openid ? "微信": "待定";
        // console.log('item.type',item)
        item.job_status = job_status[`${item.job_status}`]
        item.user_type = item.user_id ? (item.staff_id ? '会员(企业)' : '会员') : '游客'
        item.money_type = money_type[item.money_type]
          ? money_type[item.money_type].name
          : ''
        item.mode = item.mode ? '支付宝账户' : '收款人账户'
        item.status =
          status[item.status] + (item.status != 1 && item.note ? `(${item.note})` : '')
        item.scale = parseInt(item.scale) + '%'
        if (this.tab_val == '2') {
          item.type = types[item.type] ? types[item.type] : ''
        } if (this.tab_val == '0') {
          item.type = types[item.account_type] ? types[item.account_type] : ''
        } else {
          // item.type = item.type ? "支付宝" : "微信";
        }
        console.log('item', item)
      })
      return data
    },
    onChangeSelectData (e) {
      switch (e) {
        case '0': // 今日
          let now = new Date()
          this.page.start = this.$moment(now, 'YYYY-MM--DD')
          this.page.end = this.$moment(now, 'YYYY-MM--DD')
          break
        case '1': // 本月
          this.curMonth(true)
          break
        case '2': // 上月
          this.curMonth()
          break
      }
    },
    // 本月
    curMonth (isCur) {
      let now = new Date()
      let a = isCur ? 1 : 0
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0)
      this.page.start = this.$moment(last, 'YYYY-MM') + '-01'
      this.page.end = this.$moment(last, 'YYYY-MM-DD')
    },
    changeDate () {
      this.radio = ''
    },
    // 重置获取数据
    reset () {
      this.page = {
        l: 10,
        p: 0,
        date_type: 0,
        trans_no: '',
        order_no: '',
        account_name: '',
        account_id: '',
        sn: '',
        site_name: '',
        agent_name: '',
        status: -1,
        start: new Date(),
        end: new Date(),
        mode: -1
      }
      this.radio = '0'
      this.getData(1)
    },
    // 显示退款明细
    showDetail () {
      // 获取分账后退款记录
      this.getRefundData()
      this.refundModal.visible = true
    },
    // 获取分账后退款记录
    getRefundData () {
      let search = {
        start_date: this.$moment(this.refundPage.start_date, 'YYYY-MM-DD'),
        end_date: this.$moment(this.refundPage.end_date, 'YYYY-MM-DD')
      }
      search.search = this.refundPage.search
      search.p = this.refundPage.p
      search.l = this.refundPage.l
      this.GetDispenseRefund(search).then((res) => {
        this.returns = res.data
        this.refundModal.refundTotal = res.total
      })
    },
    resetRefund () {
      this.refundPage = {
        search: '',
        start_date: new Date(),
        end_date: new Date(),
        p: 0,
        l: 10
      }
      this.getRefundData() // 重置获取数据
    },
    // 导出分账后退款记录
    exportRefund (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '分账后退款记录'
      }
      this.returns_columns.map((item) => {
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all && this.refundModal.refundTotal > this.refundPage.l) {
        this.refundModal.loading = true
        let search = {
          start_date: this.$moment(this.refundPage.start_date, 'YYYY-MM-DD'),
          end_date: this.$moment(this.refundPage.end_date, 'YYYY-MM-DD'),
          p: 0,
          l: 1000000,
          search: this.refundPage.search
        }
        this.GetDispenseRefund(search).then((res) => {
          this.refundModal.loading = false
          params.data = this.formatRefundExportData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.formatRefundExportData(this.returns)
        excel.export_array_to_excel(params)
      }
    },
    refundSizeChange (l) {
      this.refundPage.l = l
      this.getRefundData()
    },
    refundPageChange (p) {
      this.refundPage.p = p - 1
      this.getRefundData()
    },
    formatRefundExportData (data) {
      data = JSON.parse(JSON.stringify(data))
      data.map((item) => {
        item.create_time = this.$moment(item.create_time)
        item.order_time = this.$moment(item.order_time)
        item.mode = item.mode ? '支付宝账户' : '收款人账户'
      })
      return data
    },
    goWithdraw () {
      window.open(config.payment, '_blank')
    },
    ...mapActions([
      'GetDispenseDetailed',
      'GetDispenseRefund',
      'GetDispenseRefundMoney',
      'GetDispenseTotal',
      'GetAngleDispenseDetailed',
      'GetDataMachine',
      'GetPayee'
    ])
  },
  computed: mapGetters({
    agent: 'agent'
  }),
  watch: {}
}
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
